import Baners from "../baners/Baners";
import SpecialBaners from "../baners/SpecialBaners";
import RecentArticles from "../recentArticles/RecentArticles";
import Sliders from "./sliders/Sliders";
import Partners from "../partners/Partners";
import CategoriesPage from "../categories/CategoriesPage";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import "./HomePage.scss";

const HomePage = () => {
  const { t } = useTranslation("home", { useSuspense: false });
  const menu = useSelector((store: any) => store.articleCategory);

  return (
    <div className="Page">
      <div className="Page-Content">
        <div className="Siders-Baners">
          <div className="Siders-Baners1">
            <Sliders />
          </div>
          <div className="Siders-Baners2">
            <SpecialBaners />
          </div>
        </div>

        <div className="Home-Page">
          <Partners title={false} />
          {menu.is_fetch && (
            <CategoriesPage
              cat1={undefined}
              cat2={undefined}
              cat3={undefined}
              menu={menu}
              getCurrentCategoryName={() => t("kategorije")}
            />
          )}
          <RecentArticles slug={null} title={t("istaknuti_proizvodi")} />
          <Baners />
        </div>
      </div>
    </div>
  );
};
export default HomePage;
